var __rspack_ns_object = JSON.parse('{"Sex":"性别","Age":"年龄","MRN":"病例号","Thickness":"厚度","Spacing":"间距","Scanner":"扫描器"}')